import { createSlice } from 'utils/@reduxjs/toolkit';
import { SearchState } from './types';
import { reducers } from './reducers';

export const initialState: SearchState = {
  queryString: '',
};

const slice = createSlice({
  name: 'search',
  initialState,
  reducers,
});

export const { actions: searchActions } = slice;
export const { reducer: searchReducer } = slice;
